import React from 'react'
import { Button, Card } from '@headtrip/components-react'
import { getGradient } from '../../templates/tutorialsBase'

const TutorialEndOfContentCta = ({ headerImg }) => {
  const gradient = getGradient(headerImg)
  return (
    <Card className={`box-gradient ${gradient.bigBox} mt-5 mb-lg-5 p-3 text-white border-0`}>
      <h5 className='uppercase color-white'>Want to contribute?</h5>
      <p className='color-white'><strong>Get Rewarded: </strong>Get up to <strong>€50</strong> in credit! Be a part of
        the community and contribute. Do it for the money. Do it for the bragging rights. And do it to teach others!</p>
      <div className='d-flex justify-content-start flex-column flex-sm-row'>
        <Button
          href='https://github.com/hetzneronline/community-content?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=get_rewarded_bottom'
          className='btnBlockResponsive mb-2 mb-sm-0 mr-0 mr-sm-3'
          variant='primary'
          target="_blank"
        >
          Submit an article
        </Button>
        <a
          href='https://github.com/hetzneronline/community-content?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=get_rewarded_bottom'
          className='btnBlockResponsive btn btn-outline-light customWhiteButton'
          target="_blank"
        >
          Find out more
        </a>
      </div>
    </Card>
  )
}

export default TutorialEndOfContentCta
